import { Input } from '@zillow/constellation-10';
import InputMask from 'react-input-mask';

interface MaskedInputProps {
  className: string;
  placeholder?: string;
  statekey?: string;
  id?: number | string;
  error?: string;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  value: any;
  onChange: any;
  onFocus?: any;
  onBlur?: any;
  type?: string;
  mask?: string | null;
}
function MaskedInput({
  className = '',
  placeholder = '',
  statekey = '',
  id = '',
  error = '',
  name = '',
  disabled = false,
  required = false,
  value = '',
  onChange,
  onFocus = () => {},
  onBlur = () => {},
  type,
  mask = null,
}: MaskedInputProps): JSX.Element {
  return (
    <>
      <InputMask
        mask={mask}
        maskChar={null}
        value={value}
        name={name}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        data-statekey={statekey}
        data-id={id}
        className={className}
        error={Boolean(error)}
        required={required}
        disabled={disabled}
        type={type}
      >
        {(inputProps) => <Input {...inputProps} />}
      </InputMask>
    </>
  );
}

export default MaskedInput;
